import * as styles from "/tools/js/svg/templates/svg.module.scss";
const SvgSpecifyListingConfigLarge = ({ title, titleId, ...props }) => {
  props = Object.assign({}, props, {
    "aria-hidden": true,
  });
  if (!props.noAlign) {
    const className = (props.className || "") + " " + styles.alignIcon;
    props = Object.assign({}, props, {
      className,
    });
  }
  return (
    <svg
      width={100}
      height={100}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M75.153 79.448H42.024v2.454h33.13v-2.454ZM75.153 74.54H42.024v2.454h33.13V74.54ZM37.117 81.902H27.3v-8.59h-2.454v11.044H39.57V73.313h-2.454v8.589ZM83.742 54.908H39.57v2.454h44.172v-2.454ZM83.742 62.27H39.57v2.454h44.172V62.27ZM35.89 53.681h-2.454v13.497H18.712V53.681h-2.454v15.95H35.89v-15.95ZM91.718 41.411H37.73v2.454h53.988v-2.454ZM91.718 31.595H37.73v2.454h53.988v-2.454ZM32.822 25.46H8.282V50h24.54V25.46Zm-2.454 22.086H10.736V27.914h19.632v19.632Z"
        fill="#374151"
      />
    </svg>
  );
};
export default SvgSpecifyListingConfigLarge;
